module.exports = __webpack_public_path__ + "img/Raw_material_new_stock.11e3154b.svg";